import type { ReactNode } from 'react';
import { cn } from 'cn';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import type { UIComponentBase } from './types';

interface ModalProps extends UIComponentBase {
  'data-testid'?: string;
  description?: ReactNode;
  onClose: () => void;
  open: boolean;
  shouldShowCloseIcon?: boolean;
  title?: ReactNode;
  titleClassName?: string;
  descriptionClassName?: string;
}

export default function Modal({
  'data-testid': dataTestId,
  children,
  className,
  description,
  onClose,
  open,
  shouldShowCloseIcon = true,
  title,
  titleClassName,
  descriptionClassName,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        showCloseButton={shouldShowCloseIcon}
        data-testid={dataTestId}
        className={cn('border-0', className)}
      >
        {(title || description) && (
          <DialogHeader>
            <DialogTitle
              asChild={true}
              className={cn(
                'text-info-800 flex justify-between text-center text-lg leading-6 font-medium',
                titleClassName,
              )}
            >
              <h3>{title}</h3>
            </DialogTitle>
            <DialogDescription asChild={true} className={cn('text-info-500 text-sm', descriptionClassName)}>
              <div>{description}</div>
            </DialogDescription>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
}
